import React from "react";
import { DataGrid } from "@mui/x-data-grid";

const PAGE_SIZE = 25;
// Wrapped headers need two to three lines; compact density scales this by 0.7
// (80 -> 56px effective).
const HEADER_HEIGHT = 80;

// Generic read-only grid for one report section. Columns come straight from
// the keys of the first row (the backend emits display-ready labels), so a new
// section or column needs no change here.
const SectionTable = ({ rows }) => {
  const sample = rows[0] ?? {};

  const columns = Object.keys(sample).map((key) => {
    const isNumber = typeof sample[key] === "number";
    return {
      field: key,
      headerName: key,
      flex: 1,
      minWidth: 140,
      type: isNumber ? "number" : "string",
      // Numbers render exactly as returned (the backend already rounds them);
      // skip the grid's default locale grouping/rounding.
      ...(isNumber && {
        valueFormatter: ({ value }) =>
          value === null || value === undefined ? "" : String(value),
      }),
    };
  });

  // Report rows carry no id, so the row index is the id.
  const gridRows = rows.map((row, index) => ({ ...row, __rowId: index }));

  return (
    <DataGrid
      sx={{
        // Long display labels wrap instead of truncating.
        "& .MuiDataGrid-columnHeaderTitle": {
          whiteSpace: "normal",
          lineHeight: 1.2,
        },
        "& .MuiDataGrid-columnHeader--alignRight .MuiDataGrid-columnHeaderTitle":
          {
            textAlign: "right",
          },
      }}
      autoHeight
      density="compact"
      headerHeight={HEADER_HEIGHT}
      rows={gridRows}
      columns={columns}
      getRowId={(row) => row.__rowId}
      pageSize={PAGE_SIZE}
      rowsPerPageOptions={[PAGE_SIZE]}
      hideFooter={rows.length <= PAGE_SIZE}
      disableSelectionOnClick
      disableColumnMenu
      // jsdom has no layout (zero-width viewport), so the virtualized grid
      // would render no headers/cells under Jest.
      disableVirtualization={process.env.NODE_ENV === "test"}
    />
  );
};

export default SectionTable;
